<template>
    <div class="rotate-container">
        <div class="card card-front text-center" :class="{ 'rotate-card-front': isFlipped }">
            <div class="card-header">
                <!-- <h5 class="mb-0">{{ title }}</h5> -->
            </div>
            <div class="card-block p-3">
                <div class="boxImage">
                    <img class="avatar" :src="avatar" alt="Avatar" />
                </div>
                
                <h4 class="card-title mb-0 fw-bold">{{ fullname }}</h4>
                <p class="fw-bold ps-3 pe-3">{{ position }}</p>
                <button class="btn btn-rotate" @click="rotateCard">
                       {{this.$t('autoret.prokurorettitujt.meshume')}}&nbsp; <font-awesome-icon icon="fa-solid fa-circle-info" class="icon"/>
                </button>
            </div>
        </div>
        <div class="card card-back text-center" :class="{ 'rotate-card-back': isFlipped }">
            <div class="card-header p-3">
                <!-- <h5>Biografia </h5> -->

              <h5> {{this.$t('autoret.prokurorettitujt.biografia')}}</h5>
            </div>
            <div class="card-block p-3">
                <!-- <h4>Të dhënat personale</h4> -->
                     <!-- <h4>{{this.$t('autoret.prokurorettitujt.biografia')}}</h4> -->
                <div>
                    <div>
                        <!-- <p class="mb-0 fw-bold">Emri dhe Mbiemri</p> -->

                         <p class="mb-0 fw-bold">{{this.$t('autoret.prokurorettitujt.emridhembiemri')}}</p>
                        <p>{{ fullname }}</p>
                    </div>
                    <!-- <div>
                      <p class="mb-0 fw-bold">{{this.$t('autoret.prokurorettitujt.datelindja')}}</p>
               
                        <p>{{ birthday }}</p>
                    </div>
                    <div>
                     <p class="mb-0 fw-bold">{{this.$t('autoret.prokurorettitujt.vendbanimi')}}</p>
                
                        <p>{{ address }}</p>
                    </div> -->
                </div>
                <ul class="social-links list-unstyled d-flex justify-content-center">
                    <li><a :href="facebook" target="_blank"><i class="fa fa-facebook"></i></a></li>
                </ul>
                <Modal v-model="showModal"
                    title="Biografia"
                    :content="cv_text"
                    icon="fa-check-circle"/>
            

                 <button v-if="cv_text.length > 4" class="btn" @click="showModal = true">
                    {{this.$t('autoret.prokurorettitujt.biografia')}}&nbsp; <font-awesome-icon icon="fa-solid fa-eye" />
                </button> <br>

           
                <button v-if="cv_url" class="btn btn-rotate " @click="openCV">
                   {{this.$t('autoret.prokurorettitujt.shiko')}} &nbsp; <font-awesome-icon icon="fa-solid fa-file-pdf" style="color:var(--color-system-secondary);" />
                </button>
  
                <br>
           
                  <button class="btn btn-rotate" @click="rotateCard">
                    <font-awesome-icon icon="fa-solid fa-circle-left" />&nbsp; {{this.$t('autoret.prokurorettitujt.kthehu')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>  
import Modal from '../../components/share/BaseModal.vue'

export default {
    name: 'ProfileCard',
    props: {
        title: { type: String, default: '' },
        avatar: { type: String, required: true },
        fullname: { type: String, required: true },
        position: { type: String, required: true },
        birthday: { type: String, default: '' },
        address: { type: String, default: '' },
        facebook: { type: String, default: '#' },
        
        cv_text: { type: String, default: '' },
         cv_url: { type: String, default: '' },
    },
    data() {
        return {
            isFlipped: false,
            showModal: false,
        }
    },
    components: {
        Modal
    },
    methods: {
        rotateCard() {
            this.isFlipped = !this.isFlipped;
        },
           openCV() {
            if (this.cv_url) {
                window.open(this.cv_url, '_blank');
            }
        }
    }
}
</script>

<style scoped>
/* Card styles for rotation */
.rotate-container {
    position: relative;
}

.rotate-container .card-front,
.rotate-container .card-back {
    width: 90%;
    height: 420px;
    transform: perspective(600px) rotateY(0deg);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    transition: all 0.5s linear 0s;
}

.rotate-container .card-back {
    transform: perspective(1600px) rotateY(180deg);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
}

.rotate-container .rotate-card-front {
    transform: perspective(1600px) rotateY(-180deg);
}

.rotate-container .rotate-card-back {
    transform: perspective(1600px) rotateY(0deg);
}

/* Modified card styles */
.card {
    box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.5);
}

.card .card-header p {
    margin: 0;
}

.card .avatar {
    height: 100%;
    width: 100%;
    aspect-ratio: 3 / 2;
    -o-object-fit: contain;
    object-fit: contain;
}

.card .btn {
    margin-bottom: 1em;
    cursor: pointer;
}

.card .social-links li {
    margin: 0.5em;
}

.card .social-links a {
    font-size: 1.5em;
}

button {
    width: 150px;
    background-color: var(--color-system-primary);
}

button:hover {
    background-color: var(--color-system-secondary);
    color: white;
}

.card-header {
    background-color: var(--color-system-secondary);
    color: white;
}

p {
    font-size: 16px;

}
.card-block p{
    line-height:18px;
}

.card-block img{
    margin-top:0px !important;
}

.boxImage{
    width: 80%;
    margin: 0 auto;
    height: 200px;
}

</style>